import axiosInstance from "./axiosInstance";

const LIPA_BIDHAA_BASE_URL = "/lipa-bidhaa";

const lipaBidhaaService = {
  verifyMerchant: async (payload) => {
    const response = await axiosInstance.post(
      `${LIPA_BIDHAA_BASE_URL}/hakikisha`,
      payload,
    );
    return response.data;
  },
  queryCharges: async (payload) => {
    const response = await axiosInstance.post(
      `${LIPA_BIDHAA_BASE_URL}/charges`,
      payload,
    );
    return response.data;
  },
  requestPayment: async (payload) => {
    const response = await axiosInstance.post(
      `${LIPA_BIDHAA_BASE_URL}/payment`,
      payload,
    );
    return response.data;
  },
  verifyPayment: async (payload) => {
    const response = await axiosInstance.post(
      `${LIPA_BIDHAA_BASE_URL}/verification`,
      payload,
    );
    return response.data;
  },
  getTransaction: async (transactionUuid) => {
    const response = await axiosInstance.get(
      `${LIPA_BIDHAA_BASE_URL}/${transactionUuid}`,
    );
    return response.data;
  },
  resendOtp: async (transactionUuid) => {
    const response = await axiosInstance.patch(
      `${LIPA_BIDHAA_BASE_URL}/${transactionUuid}/resend-otp`,
    );
    return response.data;
  },
};

export default lipaBidhaaService;
